const data = {
  topbar: {
    menu: [
      {
        text: "Contacts",
        link: "/",
        icon: "i-phone-alt",
      },
      {
        text: "Branches and ATMs",
        link: "/",
        icon: "i-map-marker-alt",
      },
      {
        text: "About us",
        link: "/",
        icon: "i-users-alt",
      },
      {
        text: "News",
        link: "/",
        icon: "i-newspaper",
      },
      {
        text: "Help",
        link: "/",
        icon: "i-shield-question",
      },
    ],
  },
};

export default data;
